import { NgModule } from '@angular/core';
import { IconComponent } from './icon/icon.component';
import { BotonVozComponent } from './boton-voz/boton-voz.component';
import { CabeceraSeccionesComponent } from './cabecera-secciones/cabecera-secciones.component';
import { CabeceraOrdenComponent } from './cabecera-orden/cabecera-orden.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from './shared';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { SearchComponent } from './search/search.component';
import { TopSearchesComponent } from './top-searches/top-searches.component';
import { UserComponent } from './user/user.component';
import { CookiesBarComponent } from './cookies-bar/cookies-bar.component';

/**
 * Componentes del "cascarón" eager (AppComponent).
 *
 * El cierre transitivo de componentes desde app.component.html (toolbar + cookies-bar)
 * es sólo estos 5: toolbar → search → top-searches, toolbar → user, y cookies-bar.
 * Sus plantillas sólo usan pipes/directivas de SharedModule (customprice, safeHtml,
 * appLazyload, appGoToUrl), así que el módulo es autocontenido y NO necesita
 * ComponentModule.
 *
 * AppModule importa SÓLO esto (antes importaba el ComponentModule de 68 componentes,
 * que arrastraba los 63 restantes a main.js aunque el root no los use). Con el split,
 * esos 63 quedan sólo tras las páginas lazy que los usan y salen del bundle inicial.
 * ComponentModule re-exporta este módulo, así que sus consumidores (páginas lazy,
 * EditorModule) siguen viendo user/toolbar/etc. sin cambios.
 */
@NgModule({
  declarations: [
    ToolbarComponent,
    SearchComponent,
    TopSearchesComponent,

    CookiesBarComponent,
  ],
  imports: [UserComponent, IconComponent, BotonVozComponent, CabeceraSeccionesComponent, CabeceraOrdenComponent,
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    SharedModule,
  ],
  exports: [
    ToolbarComponent,
    SearchComponent,
    TopSearchesComponent,
    UserComponent,
    CookiesBarComponent,
    // Filas 2 y 3 de la cabecera de escritorio (V26): la 3 la usa app-user-toolbar, de ComponentModule.
    CabeceraSeccionesComponent,
    CabeceraOrdenComponent,
  ],
})
export class ShellModule {}
